import { get } from 'lodash';
import Toast from 'utils/Toast';
import Constants from 'common/Constants';
import Monitor from 'base/utils/monitor/index';
import Url from 'url';
import { urlToAction, joinParams } from './urlToAction';

const changeActionToUrl = (uri) => {
  if (uri.path === 'ShopPlugin://com.xiaomi.shop2.plugin.goodsdetail.GoodsDetailFragment?pluginId=101') {
    const query = typeof uri.extra === 'object' ? uri.extra : JSON.parse(uri.extra || '{}');
    return joinParams(`${location.protocol}//${location.host}/mfbs/mstd/product`, query);
  } else if (uri.path === 'ShopPlugin://com.xiaomi.shop2.plugin.webview.RootFragment?pluginId=111') {
    const query = typeof uri.extra === 'object' ? uri.extra : JSON.parse(uri.extra || '{}');
    return query.url;
  } else if (uri.path === 'ShopPlugin://com.xiaomi.shop.plugin.discovery.ArticleDetailFragment?pluginId=223') {
    const query = typeof uri.extra === 'object' ? uri.extra : JSON.parse(uri.extra || '{}');
    return `${Constants.tradeUrlPrefix}discover/article/${query.article_id}/${query.type}`;
  } else if (uri.path === 'ShopPlugin://com.xiaomi.shop.plugin.shortvideo.home.HomeVideoListFragment?pluginId=232') {
    const query = typeof uri.extra === 'object' ? uri.extra : JSON.parse(uri.extra || '{}');
    return `${Constants.tradeUrlPrefix}micircle/detail/${query.moment_id_show}/99`;
  } else if ((uri.path || '').startsWith('/')) {
    return location.href + uri.path;
  }
};

const Uri = {
  getDefaultRoute: ({ uri, routes }) => {
    if (!uri) {
      return null;
    }
    let result = null;
    try {
      result = Url.parse(uri, true);
    } catch (error) {
      return null;
    }
    const query = get(result, 'query') || {};
    let action = query.action;
    action = action ? JSON.parse(decodeURIComponent(query.action)) : {};
    if (Object.keys(action).length) {
      action = {
        ...action,
        extra: action.extra ? (typeof action.extra === 'object' ? action.extra : JSON.parse(action.extra)) : undefined,
      };
    }
    return {
      ...(routes.find((item) => {
        if (
          result.pathname.indexOf('/commodity/detail') > -1 &&
          (item.MRoutes || []).find((_item) => _item.indexOf('/commodity/detail') > -1)
        ) {
          return item;
        }
        return (item.MRoutes || []).indexOf(result.pathname) > -1;
      }) || {}),
      params: query.action
        ? {
            ...action,
            ...action.extra,
            extra: undefined,
            ...query,
            action: query.action ? action : undefined,
          }
        : query,
      source: get(result, 'query.source') || '',
      sourceapp: get(result, 'query.sourceapp') || '',
      miotstore_transition_type: get(result, 'query.miotstore_transition_type') || '',
    };
  },
  openUri: async (history, uri) => {
    if (typeof uri === 'object') {
      uri = changeActionToUrl(uri);
    }
    if (typeof uri === 'object' || !uri) {
      Toast.show('更多精彩，请下载小米商城App查看');
      return;
    }
    const u = urlToAction(uri);
    // history.go(u);
    await Monitor.sendData();
    window.location.href = u;
  },
  back: async (navigator) => {
    await Monitor.sendData();
    window.history.go(-1);
  },
  finishAndOpenUrl: (url) => this.openUri(url),
};
export { Uri };

export default Uri;
